import {t} from "i18next";

export const AGGREGATORS = {
    sum: 'sum',
    sumPlus: 'sumPlus',
    count: 'count',
    mostUsed: 'mostUsed',
    sumOfNegativeValues: 'sumOfNegativeValues',
    sumOfPositiveValues: 'sumOfPositiveValues',
    percentage: 'percentage',
    average: 'average',
    mostUsedPercentage: 'mostUsedPercentage',
    uniqueCount: 'uniqueCount',
    averageOfPercentages: 'averageOfPercentages',
    totalHoursCalc: 'totalHoursCalc',
    strongestHour: 'strongestHour',
    totalHoursMinutes: 'totalHoursMinutes',
    occupancyPercentage: 'occupancyPercentage',
    mostUsedNumber: 'mostUsedNumber',
    mostUsedPercentageWithNumber: 'mostUsedPercentageWithNumber',
    occupancyPercentageWithNumber: 'occupancyPercentageWithNumber',
    mostUsedPercentageFromCount: 'mostUsedPercentageFromCount',
    sumOfArrayLength: 'sumOfArrayLength'
};

export const TIME_RANGE_OPTIONS = {
    today: 'today',
    yesterday: 'yesterday',
    tomorrow: 'tomorrow',
    thisMonth: 'thisMonth',
    prevMonth: 'prevMonth',
    lastThirtyDays: 'lastThirtyDays',
    thisWeek: 'thisWeek',
    lastSevenDays: 'lastSevenDays',
    lastFourteenDays: 'lastFourteenDays',
    thisYear: 'thisYear',
    nextWeek: 'nextWeek',
    nextTwoWeeks: 'nextTwoWeeks',
    all: 'all',
    custom: 'customDate',
    nextMonth: 'nextMonth',
    lastTwelveMonths: 'lastTwelveMonths',
    nextSevenDays: 'nextSevenDays',
    nextThirtyDays: 'nextThirtyDays',
    untilEndOfMonth: 'untilEndOfMonth',
    thisMonthUntilNow: 'thisMonthUntilNow',
    lastWeek: 'week1',
    thisEightWeeks: 'thisEightWeeks',
    thisFourWeeks: 'thisFourWeeks',
    thisThreeMonths: 'thisThreeMonths',
    thisSixMonths: 'thisSixMonths',
    dateIsNull: 'dateIsNull'
};

export const FILTER_TYPES = {
    string: 'string',
    dateRange: 'date_range',
    dateTimeRange: 'date_time_range',
    multiSelect: 'multi_select',
    multiSelectContains: 'multi_select_contains',
    numberRange: 'number_range',
    search: 'search',
    timeRange: 'time_range',
    birthdayRange: 'birthdayRange',
    dateOrNever: 'dateOrNever',
    numberRangeFromString: 'numberRangeFromString',
    totalHours: 'totalHours',
    customFieldValue: 'customFieldValue',
    shortDate: 'shortDate',
    searchInNote: 'searchInNote'
};

export const SORT_TYPES = {
    number: 'number',
    string: 'string',
    date: 'date',
    time: 'time',
    birthday: 'birthday',
    dateOrNever: 'dateOrNever',
    numberFromString: 'numberFromString',
    totalHours: 'totalHours',
    customFieldValue: 'customFieldValue',
    shortDate: 'shortDate'
};

export const RENDER_TYPES = {
    number: 'number',
    string: 'string',
    date: 'date',
    time: 'time',
    dateTime: 'dateTime',
    user: 'user',
    birthdayDate: 'birthdayDate',
    tag: 'tag',
    colorTag: 'colorTag',
    phone: 'phone',
    absoluteNum: 'absoluteNum',
    hour: 'hour',
    generalTag: 'generalTag',
    messageDetails: 'messageDetails',
    longString: 'longString',
    resendMessage: 'resendMessage',
    taskTag: 'taskTag',
    editableSelect: 'editableSelect',
    deleteRow: 'deleteRow',
    eventManage: 'eventManage',
    tasksTargetUser: 'tasksTargetUser',
    editableTaskTypeColor: 'editableTaskTypeColor',
    staffMember: 'staffMember',
    targetUser: 'targetUser',
    minutes: 'minutes',
    percentage: 'percentage',
    email: 'email',
    customFieldValue: 'customFieldValue',
    money: 'money',
    shortDate: 'shortDate',
    wage: 'wage',
    numberAsString: 'numberAsString',
    userFinance: 'userFinance',
    priceOnPurchase: 'priceOnPurchase',
    link: 'link',
    durationWithTooltip: 'durationWithTooltip',
    numberWithTrend: 'numberWithTrend',
    note: 'note',
    linkWithCopy: 'linkWithCopy'
};

export const REPORT_ACTIONS = {
    sms: 'sms',
    push: 'push',
    email: 'email',
    markLostLeads: 'markLostLeads',
    updateLeadsStatus: 'updateLeadsStatus',
    multiHolds: 'multiHolds',
    reviveLead: 'reviveLead',
    shiftAdd: 'shiftAdd',
    shiftDelete: 'shiftDelete',
    multipleUpdate: 'multipleUpdate',
    multipleUpdateSubscription: 'multipleUpdateSubscription',
    sendWelcomeEmail: 'sendWelcomeEmail',
    removeRestrictions: 'removeRestrictions',
    markAsLost: 'markAsLost',
    updateStatus: 'updateStatus',
    sendMessages: 'sendMessages',
    filters: 'filters',
    task: 'task',
    multiHoldsUpdate: 'multiHoldsUpdate',
    updateLeadOwner: 'updateLeadOwner',
    updateLeadSource: 'updateLeadSource',
    updateLostReason: 'updateLostReason',
    deleteLead: 'deleteLead',
    sendLinkToPurchase: 'sendLinkToPurchase',
    sendLinkToPurchaseItems: 'sendLinkToPurchaseItems',
    sendLinkToPurchaseHugim: 'sendLinkToPurchaseHugim',
    multiPlanPurchase: 'multiPlanPurchase',
    multiPunchCardPurchase: 'multiPunchCardPurchase',
    convertToLeadAndMarkAsLost: 'convertToLeadAndMarkAsLost',
    kioskCloseDebtLink: 'kioskCloseDebtLink',
    sendLinkToConvert: 'sendLinkToConvert',
    sendDoctorJournalReport: 'sendDoctorJournalReport',
    downloadDoctorJournalReport: 'downloadDoctorJournalReport',
};
export const DATE_OPTIONS = [
    {id: "day", name: "days"},
    {id: "week", name: "weeks"},
    {id: "month", name: "months"}
]

export const MEMBER_PROPERTIES = [
    {value: "has_waiver", label: "waiver"},
    {value: "medical_cert", label: "medicalCertificate"},
    {value: "has_insurance", label: "hasInsurance"},
    {value: "restricted", label: "isRestricted"},
];

export const MESSAGE_TABS = {
    received: 'received',
    removals: 'removals',
    failed: 'failed',
    content: 'content'
}

export const MESSAGE_REPORTS_AUDIENCE = [
    {value: 'PrivateMessage', db: 'privateMessage'},
    {value: 'ReportMessage', db: 'reportMessage'},
    {value: 'NonActiveMembersMessage', db: 'nonActiveMembers'},
    {value: 'ActiveMembersMessage', db: 'activeMembers'},
    {value: 'OpenLeadsMessage', db: 'openLeads'},
    {value: 'LostLeadsMessage', db: 'lostLeads'},
    {value: 'StaffMembersMessage', db: 'staffMembers'},
];

export const DIRECTIONS = {
    vertical: 'vertical',
    horizontal: 'horizontal'
}

export const REPORT_TYPES = {
    detailed: 'detailed',
    summary: 'summary',
    custom: 'custom',
    graphs: 'graphs',
    customGraphTab: 'customGraphTab'
}

export const actionSubActionFilterOptions = [
    {
        id: "extra enrollment",
        label: "extraEnrollmentAction",
    },
    {
        id: "created new",
        label: "UserLogCreatedNewAction",
    },
    {
        id: "converted to member",
        label: "UserLogConvertedToMember",
    },
    {
        id: "renew",
        label: "UserLogRenewAction",
    },
    {
        id: "renew subsidy",
        label: "RenewSubsidy",
    },
    {
        id: "purchase",
        label: "UserLogPurchaseAction",
    },
    {
        id: "new purchase",
        label: "UserLogNewPurchaseAction",
    },
    {
        id: "lead converted purchase",
        label: "UserLogLeadConvertedPurchaseAction",
    },
    {
        id: "debt",
        label: "debt",
    },
    {
        id: "purchase occasion",
        label: "inPurchaseOccasion",
    },
    {
        id: "recurring sales",
        label: "recurringSalePurchase",
    },
    {
        id: "no receipt payment",
        label: "cashPurchase",
    },
    {
        id: "separated payment",
        label: "separatedPayment",
    },
    {
        id: "excel download",
        label: "exportToExcel",
    },
    {
        id: "debt reduce",
        label: "UserLogDebtReduceAction",
    },
    {
        id: "edit debt",
        label: "UserLogDebtReduceAction",
    },
    {
        id: "edit sessions",
        label: "UserLogEditSessionsAction",
    },
    {
        id: "suspension",
        label: "UserLogSuspensionAction",
    },
    {
        id: "cancel suspension",
        label: "UserLogCancelSuspensionAction",
    },
    {
        id: "edit suspension",
        label: "UserLogEditSuspensionAction",
    },
    {
        id: "converted from coach to member",
        label: "UserLogMembershipConvertedCoachToMember",
    },
    {
        id: "converted from member to coach",
        label: "UserLogMembershipConvertedMemberToCoach",
    },
    {
        id: "cancel",
        label: "UserLogCancelAction",
    },
    {
        id: "edit dates",
        label: "UserLogEditDatesAction",
    },
    {
        id: "restricted",
        label: "UserLogRestrictedAction",
    },
    {
        id: "unrestricted",
        label: "UserLogUnrestrictedAction",
    },
    {
        id: "note",
        label: "noteAction",
    },
    {
        id: "membership fine",
        label: "membershipFine",
    },
    {
        id: "recurring payments",
        label: "recurringPaymentSettingPage",
    },
    {
        id: "chip burned",
        label: "burnChip",
    },
    {
        id: "chip deleted",
        label: "burnDeleted",
    },
    {
        id: "edit price",
        label: "editPrice",
    },
    {
        id: "cancel document",
        label: "cancelDocumentToolTip",
    },
    {
        id: "replace membership type",
        label: "replacedMembershipType",
    },
    {
        id: "sales person change",
        label: "replacedSalesPerson",
    },
    {
        id: "group membership",
        label: "UserLogGroupAction",
    },
    {
        id: "medical card deleted",
        label: "medicalCertDeleted",
    },
    {
        id: "has waiver deleted",
        label: "hasWaiverDeleted",
    },
    {
        id: "medical cert uploaded",
        label: "medicalCertUploaded",
    },
    {
        id: "has waiver uploaded",
        label: "hasWaiverUploaded",
    },
    {
        id: "extra membership",
        label: "extraMembership",
    },
    {
        id: "staff",
        label: "staff",
    },
    {
        id: "refund",
        label: "membershipCanceRefund",
    },
    {
        id: "refund separated payment",
        label: "UserLogCreditItemBalance",
    },
    {
        id: "decline",
        label: "UserLogDecline",
    },
    {
        id: "debt close",
        label: "UserLogSuccessfulChargeInAttempt",
    },
    {
        id: "debt open",
        label: "UserLogDebtCreated",
    },
    {
        id: "deactivate",
        label: "UserLogAutoActionSetInActive",
    },
    {
        id: "activate",
        label: "UserLogAutoActionSetActive",
    },
    {
        id: "updated",
        label: "UserLogUpdateRecurringPaymentsDetailsDay",
    },
    {
        id: "multiple update",
        label: "UserLogMultiUpdateRecurringPaymentsDetailsDay",
    },
    {
        id: "restore",
        label: "chargeCycleRestore",
    },
    {
        id: "delete",
        label: "chargeCycleCancelled",
    },
    {
        id: "booked without membership",
        label: "UserLogBookedWithoutMembershipAction"
    },
    {
        id: "booked without membership hug",
        label: "UserLogBookedWithoutMembershipHugAction"
    },
    {
        id: "unknown",
        label: "unknown",
    },
    {
        id: "cancellation restore",
        label: 'cancellationRestore'
    },
    {
        id: "lead created",
        label: "leadCreatedAction"
    },
    {
        id: "lead update status",
        label: "leadUpdateStatus"
    },
    {
        id: "assign lead owner",
        label: "assignLeadOwner"
    },
    {
        id: "update lead owner",
        label: "updateLeadOwner"
    },
    {
        id: "update lead owner of member",
        label: "UpdateLeadOwnerOfMember"
    },
    {
        id: "converted to lead",
        label: "convertedToLead"
    },
    {
        id: "send convert link",
        label: "UserLogSendConvertLinkAction"
    },
    {
        id: "send debt link",
        label: "UserLogSendDebtLinkAction"
    },
    {
        id: "send confirmation link",
        label: "UserLogSendConfirmationLinkAction"
    },
    {
        id: "restore user",
        label: "UserLogRestoreUser"
    },
    {
        id: "archive user",
        label: "UserLogArchiveUser"
    },
];

export const CUSTOM_FIELD_TYPES = {
    date: 'date',
    number: 'number',
    text: 'text',
    select: 'select',
    boolean: 'boolean',
    phone: 'phone'
}

//this is BS workaround to pass to SEND_LINK_TO_MEMBERSHIP_FLOW if we should hide membership type with prop "NEW_USERS_MEMBERSHIP" or not (aka only on leads)
export const LEADS_REPORTS = [
    'all-leads-report',
    'leads-in-process-report',
    'lost-leads-report',
    'trial-classes-report'
]